/* Copyright (C) Envialo México SA de CV - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by:
 * @author América Mendoza  <amendoza@nodeport.co>,
 * @author Darién Miranda <dmiranda@nodeport.co>,
 * @author Oscar Peña <opena@nodeport.co>,
 * December 2021
 */

import React from 'react';
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import NbioApi from "../lib/api/NbioApi";
import BootstrapTable from "react-bootstrap-table-next";
import cellEditFactory, {Type} from 'react-bootstrap-table2-editor';
import {money} from "../lib/money/money";
import {withRouter} from "react-router";
import Swal from "sweetalert2";
import Alert from "react-bootstrap/Alert";
import {toast, Toaster} from "sonner";

//components
import ImageSelector from "../components/ui/ImageSelector";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import NPIf from "np-if";
import PropTypes from "prop-types";
import InputGroup from "react-bootstrap/InputGroup";
import FormControl from "react-bootstrap/FormControl";
import {FormSelect} from "react-bootstrap";
import ListGroupItem from "react-bootstrap/ListGroupItem";
import ListGroup from "react-bootstrap/ListGroup";

class ProvidersEditorComponent extends React.Component {
    state = {
        query: '',
        providers:[],
        value:''
    }
    componentDidMount() {
        this.loadProviders         = this.loadProviders.bind(this);
        this.afterProviderCreation = this.afterProviderCreation.bind(this);
        this.loadProviders();
    }
    onSaveProvider = async (name) =>{
        return NbioApi.providers.addProvider(name);
    }
    afterProviderCreation = async (res) =>{
        await this.loadProviders();
        this.props.onUpdate(res?.data?.provider?.name);
    }
    onSaveProviderWrapper = (name) =>{
        // setIsSaving(true);
        toast.promise(this.onSaveProvider(name), {
            loading: 'Guardando proveedor',
            success: (res) => {
                setTimeout(() =>{
                    this.afterProviderCreation(res);
                },1000);
                return 'Proveedor Guardado'
            },
            error: (ex) =>{
                return(ex?.response?.data?.localized_error || ex?.message || 'Error al guardar proveedor');
            },
            finally:() =>{
            }
        });
    };
    addProvider(){
        Swal.fire({
            title:'Agrega un proveedor',
            html:'Ingresa el nombre de la farmacia',
            input: 'text',
            confirmButtonColor: '#27d4f3',
            confirmButtonText: 'Agregar',
            cancelButtonText: 'Cancelar',
            showCancelButton: true,
            preConfirm: (provider) => {
                if(!provider){
                    Swal.showValidationMessage(
                        `El nombre no puede estar vacío`
                    )
                }else{
                    return provider;
                }
            },
            heightAuto:false
        }).then((res) =>{
            if(res.isConfirmed){
                this.onSaveProviderWrapper(res.value);
            }
        });
}
    loadProviders = async (preselectProviderName = '') => {
        try{
            const res = await NbioApi.providers.get();
            let providers = (res.data?.providers || []).map((p) => {
                return {
                    value: p.name,
                    label: p.name
                }
            });
            providers = [
                {
                    value:'addProvider',
                    label:'Agregar proveedor...'
                },
                ...providers
            ]
            this.setState({
                providers: providers,
                setLoadingProviders:false
            })
        }catch(e){

        }
    }

    static propTypes = {
        value: PropTypes.number,
    }
    static defaultProps = {
        value: ''
    }
    getValue() {
        return this.state.value;
    }
    onSearch(event){
        NbioApi.providers.search(event.target.value).then((res) =>{
            console.log(res.data);
            let providers = (res.data?.providers || []).map((p) => {
                return {
                    value: p.name,
                    label: p.name
                }
            });
            providers = [
                {
                    value:'addProvider',
                    label:'Agregar proveedor...'
                },
                ...providers
            ]
            this.setState({
                providers: providers
            })
        }).catch((ex) =>{

        })

    }
    render() {
        const {value, onUpdate, ...rest} = this.props;
        return <div>
            <InputGroup>
                <InputGroup.Text>
                    <FontAwesomeIcon icon={"search"}/>
                </InputGroup.Text>
                <FormControl
                    id={'query'}
                    type={'text'}
                    placeholder="Buscar proveedor"
                    onKeyUp={event => {
                        if (event.keyCode === 13) {
                            this.onSearch(event);
                        }
                    }}
                    onChange={event => this.onSearch(event)}
                />

            </InputGroup>
            <ListGroup style={{maxHeight:'300px',overflow:'auto'}}>
                {
                    this.state.providers.map((provider) =>{
                        return <ListGroupItem key={provider.label} onClick={() =>{
                            if(provider.value === 'addProvider'){
                                this.addProvider();
                            }else{
                                this.setState({value:provider.value});
                                this.props.onUpdate(provider.value);
                            }
                        }}>
                            {provider.label}
                        </ListGroupItem>
                    })
                }
            </ListGroup>
            {/*<FormSelect onChange={(ev) => {*/}
            {/*    this.setState({value:ev.target.value})*/}
            {/*    this.props.onUpdate(ev.target.value);*/}
            {/*}}>*/}
            {/*    {*/}
            {/*        this.state.providers.map((provider) =>{*/}
            {/*            return <option>{provider.label}</option>*/}
            {/*        })*/}
            {/*    }*/}

            {/*</FormSelect>*/}
        </div>
    }
}
class ValidateAmountView extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            order: {
                shipping: {},
                shippingMethod:{},
                items:[],
                user:{},
                logs:[],
                coupons:[]
            },
            items: [],
            rowIndex: -1,
            isEdited: false,
            selectedImage: '',
            isValidating:false,
            isEditing:false,
            hasDiscount:false,
            providers:[],
            saleSchemas:[
                {
                    value:'sale',
                    label:'Venta',
                },
                {
                    value:'commission',
                    label:'Comisión'
                }
            ]
        }

        this.loadOrder                      = this.loadOrder.bind(this);
        this.updateValidatePriceField       = this.updateValidatePriceField.bind(this);
        this.cancelValidate                 = this.cancelValidate.bind(this);
        this.validateOrder                  = this.validateOrder.bind(this);
        this.confirmationValidateOrder      = this.confirmationValidateOrder.bind(this);
        this.areAmountsValid                = this.areAmountsValid.bind(this);
    }

    componentDidMount() {
        this.loadOrder();
    }

    areAmountsValid(){
        const items = this.state.items;
        const hasInvalidItem = items.some((i) =>{
            return i.validatedPrice <= 0 || isNaN(parseFloat(i.validatedPrice));
        })
        const areAmountsValid = !hasInvalidItem;
        return areAmountsValid;
    }
    saleSchemaHelper(label){
        if(label === 'Venta'){
            return 'sale';
        }else if(label === 'Comisión'){
            return 'commission';
        }
    }
    async validateOrder(){
        const orderId = this.props.match.params.id;
        this.setState({isValidating:true});
        if(!this.state.order?.isPriceValidated){
            for (let ii = 0; ii < this.state.items.length ; ii++){
                const currentItem = this.state.items[ii];
                await NbioApi.orders.updateField(orderId,currentItem._id,'origin',currentItem.origin);
                await NbioApi.orders.updateField(orderId,currentItem._id,'saleSchema',this.saleSchemaHelper(currentItem.saleSchema));
                await NbioApi.orders.updateField(orderId,currentItem._id,'cost',currentItem.cost);

            }
        }

        NbioApi.orders.validateAmount(orderId,this.state.items).then((res) =>{
            Swal.fire({
                icon:'success',
                title:'Cantidad validada',
                confirmButtonColor: '#4dda85',
                didClose: (e) => {
                    this.setState({isValidating:false});
                    this.props.history.goBack();
                },
                heightAuto:false
            })

        }).catch((ex) =>{
            const data = ex.response.data;
            Swal.fire({
                icon:'error',
                title:'Hubo un problema al validar la cantidad',
                text:data.error_es,
                heightAuto:false
            })
            this.setState({isValidating:false});
        })
    }

    loadOrder(){
        const orderId = this.props.match.params.id;
        NbioApi.orders.getOrder(orderId).then((res) => {
            const selectedImage = res.data.order.tickets.length > 0 ? res.data.order.tickets[0].imageUrl : '';
            const hasDiscount = res.data.order.items.some((i) => !!i.discount);
            this.setState({
                order: res.data.order,
                items: this.generateInitItems(res.data.order),
                selectedImage: selectedImage,
                hasDiscount: hasDiscount
            });
        })
        this.loadProviders();
    }
    loadProviders = async (preselectProviderName = '') => {
        try{
            const res = await NbioApi.providers.get();
            let providers = (res.data?.providers || []).map((p) => {
                return {
                    value: p.name,
                    label: p.name
                }
            });
            providers = [
                {
                    value:'addProvider',
                    label:'Agregar proveedor...'
                },
                ...providers
            ]
            this.setState({
                providers: providers,
                setLoadingProviders:false
            })
        }catch(e){

        }
    }
    generateInitItems(order){
        const coupons = order.coupons || [];
        let items = order.items;
        if(coupons.length === 0){
            items = items.map((i) => {
                i.origin = '';
                i.saleSchema = '';
                return i;
            });
            return items;
        }else{
            // d1 = devolucion
            // d2 = subtotalValidado
            items = items.map((i) => {
                i.d1 = 0;
                i.d2 = i.price * i.quantity;
                i.validatedPrice = i.price;
                i.origin = '';
                i.saleSchema = '';
                return i;
            });
            return items;
        }



    }
    updateValidatePriceField(oldValue, newValue,row,column){
        const {rowIndex}  = this.state;
        const items = [...this.state.items];
        if(column?.dataField === "validatedPrice") {
            items[rowIndex].validatedPrice = newValue;
            items[rowIndex].d1 = items[rowIndex].price - newValue < 0 ? 0 : items[rowIndex].price - newValue;
            items[rowIndex].d2 = newValue * items[rowIndex].quantity;
        }
        else if(column?.dataField === "origin") {
                // items[rowIndex].origin = '123';
                // const foundProvider = this.state.providers.find((p) => p.value === newValue);
                // debugger;
                // items[rowIndex][column.dataField] = '';
                //
                // if(foundProvider.value === 'addProvider'){
                //     Swal.fire({
                //         title:'Agrega un proveedor',
                //         html:'Ingresa el nombre de la farmacia',
                //         input: 'text',
                //         confirmButtonColor: '#27d4f3',
                //         confirmButtonText: 'Agregar',
                //         cancelButtonText: 'Cancelar',
                //         showCancelButton: true,
                //         preConfirm: (provider) => {
                //             if(!provider){
                //                 Swal.showValidationMessage(
                //                     `El nombre no puede estar vacío`
                //                 )
                //             }else{
                //                 return provider;
                //             }
                //         },
                //         heightAuto:false
                //     }).then((res) =>{
                //         if(res.isConfirmed){
                //             this.onSaveProviderWrapper(res.value,rowIndex,column.dataField);
                //         }
                //     });
                // }else{
                //     items[rowIndex][column.dataField] = foundProvider.value;
                // }

        }
        else if(column?.dataField === "saleSchema"){
            const foundSaleSchema = this.state.saleSchemas.find((p) => p.value === newValue);
            items[rowIndex][column.dataField] = foundSaleSchema.label;
        }
        else if(column?.dataField === "cost") {
            items[rowIndex][column.dataField] = newValue;
        }


        // update refund

        //Update the item array and the flag value
        this.setState({
            isEdited:true,
            items:items
        });
    }


    cancelValidate(){
        this.setState({
            isEdited:false,
            items:this.state.order.items
        }, () => {
            this.props.history.goBack();
        });
    }

    confirmationValidateOrder(){
        const validatedAmount = this.state.items.map((i) => parseFloat(i.validatedPrice) * i.quantity).reduce((a, b) => a + b, 0);
        const totalAmount = this.state.order.subTotal  -  validatedAmount;
        let text =  ''
        if(totalAmount >= 0){
            text = `El cliente tendrá una devolución de  ${money(totalAmount)}`;
        }else{
            text = 'El cliente no tendrá devolución';
        }

        Swal.fire({
            title: 'Validar monto',
            html: text,
            confirmButtonText: 'Validar',
            cancelButtonText: 'Cancelar',
            confirmButtonColor: '#4dda85',
            showConfirmButton: true,
            showCancelButton: true,
            allowOutsideClick: false,
            heightAuto:false
        }).then((result) => {
            /* Read more about handling dismissals below */
            if (result.isConfirmed) {
                if(this.areAmountsValid()){
                    this.validateOrder();
                }else{
                    toast.error("Datos inválidos");
                }
            } else if(result.dismiss === Swal.DismissReason.cancel){
                console.log('validated amount cancel');
            }
        })
    }
    //Header formatter of column validatedPrice
    validatedPriceFormatter = (column, colIndex) => {
        return(
            <OverlayTrigger
                key={'validatedPrice'}
                placement={'bottom'}
                overlay={
                    <Tooltip id={`tooltip-validatedPrice`}>
                        Escribe el precio real del producto.
                    </Tooltip>
                }
            >
                <span className='text-primary'>{column.text} <FontAwesomeIcon icon={'question-circle'}/></span>
            </OverlayTrigger>
        )
    }
    originFormatter = (column, colIndex) => {
        return(
            <OverlayTrigger
                key={'origin'}
                placement={'bottom'}
                overlay={
                    <Tooltip id={`tooltip-validatedPrice`}>
                        El origen del producto a entregar
                    </Tooltip>
                }
            >
                <span className='text-primary'>{column.text} <FontAwesomeIcon icon={'question-circle'}/></span>
            </OverlayTrigger>
        )
    }
    saleSchemaFormatter = (column, colIndex) => {
        return(
            <OverlayTrigger
                key={'origin'}
                placement={'bottom'}
                overlay={
                    <Tooltip id={`tooltip-validatedPrice`}>
                        El esquema del producto
                    </Tooltip>
                }
            >
                <span className='text-primary'>{column.text} <FontAwesomeIcon icon={'question-circle'}/></span>
            </OverlayTrigger>
        )
    }
    //Refund formatter of column
    refundFormatter = (column, colIndex) => {
        return(
            <OverlayTrigger
                key={'refund'}
                placement={'bottom'}
                overlay={
                    <Tooltip id={`tooltip-refund`}>
                        La Devolución se calcula automaticamente al escribir el precio validado.
                    </Tooltip>
                }
            >
                <span>{column.text} <FontAwesomeIcon icon={'question-circle'}/></span>
            </OverlayTrigger>
        )
    }

    //Refund formatter of column
    subtotalFormatter = (column, colIndex) => {
        return(
            <OverlayTrigger
                key={'subtotal'}
                placement={'bottom'}
                overlay={
                    <Tooltip id={`tooltip-subtotal`}>
                        El Subtotal Validado se calcula automáticamente al escribir el precio validado.
                    </Tooltip>
                }
            >
                <span>{column.text} <FontAwesomeIcon icon={'question-circle'}/></span>
            </OverlayTrigger>
        )
    }
    costFormatter = (column, colIndex) => {
        return(
            <OverlayTrigger
                key={'cost'}
                placement={'bottom'}
                overlay={
                    <Tooltip id={`tooltip-subtotal`}>
                        El costo del producto a entregar
                    </Tooltip>
                }
            >
                <span>{column.text} <FontAwesomeIcon icon={'question-circle'}/></span>
            </OverlayTrigger>
        )
    }
    render(){
        let items = this.state.items ? this.state.items : [];
        const order = this.state.order ? this.state.order : {};
        const selectedImage = this.state.selectedImage;

        const columns  = [
            {
                dataField: 'description',
                text:'Producto',
                editable: false,
                headerStyle:() =>{
                    return {
                        width:'250px'
                    }
                },
                formatter:(value,row) => {
                    return(
                        <div>
                            <div>{row.SKU} - {value}</div>
                        </div>
                    )
                }
            },
            {
                dataField: 'price',
                text:'Precio',
                editable: false,
                formatter:(value,row) =>{
                    const discount = row.discount ? row.discount : null;
                    const originalPrice =  discount ? row.originalPrice : 0;
                    if(discount){
                        return (
                            <div>
                                <div className={'strikethrough'}>
                                    {money(originalPrice)}
                                </div>
                                <div className={'discounted-price'}>
                                    <b>{money(value)}</b>
                                </div>
                                <div>
                                    <small>
                                        <FontAwesomeIcon icon={"percentage"} />&nbsp;{discount.name}
                                    </small>
                                </div>
                            </div>
                        )
                    }else{
                        return (
                            <div>
                                {money(value)}
                            </div>
                        )
                    }

                }
            },
            {
                dataField: 'quantity',
                text:'Cantidad',
                editable: false
            },
            {
                dataField: 'price',
                text:'Subtotal',
                editable: false,
                formatter:(value,row) =>{
                    const discount = row.discount ? row.discount : null;
                    const originalPrice =  discount ? row.originalPrice : 0;
                    if(discount){
                        return (
                            <div>
                                <div className={'strikethrough'}>
                                    {money(originalPrice * row.quantity)}
                                </div>
                                <div className={'discounted-price'}>
                                    {money(value)}
                                </div>
                            </div>
                        )
                    }else{
                        return (
                            <div>
                                {money(value * row.quantity)}
                            </div>
                        )
                    }
                }
            },
            {
                dataField: 'd1',
                isDummyField: false,
                text:'Devolución',
                editable: false,
                formatter(value,row,i){
                    if(!value){
                        return '-';
                    }else{
                        return `${money(value)} X ${row.quantity}`;
                    }
                },
                headerFormatter: this.refundFormatter
            },
            {
                dataField: 'd2',
                isDummyField: false,
                text:'Subtotal Validado',
                editable: false,
                formatter(value,row,i){
                    if(!value){
                        return '-';
                    }else{
                        return money(value);
                    }
                },
                headerFormatter: this.subtotalFormatter
            },
            {
                dataField: 'validatedPrice',
                text:'Precio Validado',
                headerStyle:() =>{
                    return {
                        width:'150px'
                    }
                },
                headerFormatter: this.validatedPriceFormatter,
                validator: (newValue, row, column) => {
                    const value = newValue.trim();

                    if (isNaN(value)) {
                        return {
                            valid: false,
                            message: 'El precio validado debe ser numérico.'
                        };
                    }
                    if (value === '') {
                        return {
                            valid: false,
                            message: 'El precio no puede ser vacío.'
                        };
                    }
                    if (newValue <= 0) {
                        return {
                            valid: false,
                            message: 'El precio debe ser mayor a 0.'
                        };
                    }
                    return true;
                }
            },
            {
                dataField: 'origin',
                text:'Origen',
                headerStyle:() =>{
                    return {
                        width:'250px'
                    }
                },
                headerFormatter: this.originFormatter,
                editorRenderer: (editorProps, value, row, column, rowIndex, columnIndex) => (
                    <ProvidersEditorComponent { ...editorProps } value={ value } />
                ),
                validator: (newValue, row, column) => {
                    const value = newValue.trim();
                    if (!value?.trim()) {
                        return {
                            valid: false,
                            message: 'El origen no puede estar vacío.'
                        };
                    }
                    return true;
                }
            },
            {
                dataField: 'saleSchema',
                text:'Esquema',
                headerStyle:() =>{
                    return {
                        width:'200px'
                    }
                },
                headerFormatter: this.saleSchemaFormatter,
                editor: {
                    type: Type.SELECT,
                    options: this.state.saleSchemas
                },
                validator: (newValue, row, column) => {
                    const value = newValue.trim();
                    if (!value?.trim()) {
                        return {
                            valid: false,
                            message: 'El esquema no puede estar vacío.'
                        };
                    }
                    return true;
                }
            },
            {
                dataField: 'cost',
                text:'Costo',
                headerStyle:() =>{
                    return {
                        width:'200px'
                    }
                },
                headerFormatter: this.costFormatter,
                validator: (newValue, row, column) => {
                    const value = newValue.trim();
                    if (!value?.trim()) {
                        return {
                            valid: false,
                            message: 'El costo no puede estar vacío.'
                        };
                    }
                    return true;
                }
            },

        ];
        const isTableEditable = this.state.order.coupons.length > 0;
        const hasDiscount = this.state.hasDiscount;

        return(
            <Container fluid className={'h-100 d-flex flex-column'}>
                <Toaster />
                <Row>
                    <Col>
                        <Card.Body  className={'d-flex justify-content-between align-items-center'}>
                            <h5 className={'text-capitalize'}>Validar Monto
                                <span className={'pl-1 text-info'}><small>#{order._id}</small></span>
                            </h5>
                            <Button variant={"light"}
                                    onClick={() => {this.props.history.goBack()}}
                                   >
                                <FontAwesomeIcon icon={"times"}/>
                            </Button>
                        </Card.Body>
                    </Col>
                </Row>

                <Row className={'flex-grow-1 mt-2'}>
                    <Col sm={12} md={3} >
                        <ImageSelector images={order.tickets}
                                       selectedImage={selectedImage}
                                       onImageSelected={(img) => this.setState({selectedImage:img})} >
                        </ImageSelector>
                    </Col>
                    <Col sm={12} md={9}>
                        <NPIf condition={isTableEditable}>
                            <Alert variant={'warning'}>
                                Nota: En las órdenes que incluyen cupones el precio validado no puede ser modificado. Presione Validar montos para continuar.
                            </Alert>
                        </NPIf>
                        <NPIf condition={hasDiscount}>
                            <Alert variant={'warning'}>
                                Nota: Esta orden incluye precios con descuentos. El precio original es el que se encuentra tachado. El precio después del descuento es el que no se encuentra tachado.
                            </Alert>
                        </NPIf>
                        <Card>
                            <BootstrapTable keyField='id'
                                            data={items}
                                            columns={columns}
                                            noDataIndication={``}
                                            bordered={false}
                                            striped
                                            condensed={true}
                                            tabIndexCell={true}
                                            cellEdit={ cellEditFactory({
                                                mode: isTableEditable ? 'none' : 'click',
                                                blurToSave: true,

                                                onStartEdit: (row, column, rowIndex) => {
                                                    this.setState({rowIndex:rowIndex,isEditing:true})
                                                },
                                                beforeSaveCell: (oldValue, newValue,row,column) => {
                                                    this.updateValidatePriceField(oldValue,newValue,row,column)
                                                },
                                                afterSaveCell: (oldValue, newValue,row,column,) => {
                                                    this.updateValidatePriceField(oldValue,newValue,row,column)
                                                    this.setState({isEditing:false})
                                                }
                                            }) }
                            />
                        </Card>
                    </Col>
                </Row>
                <Row className={'mt-auto mb-3'}>
                    <Col>
                        <Card.Body  className={'d-flex justify-content-end'}>
                            <Button className={'mr-1'} variant={"danger"} size="sm"  onClick={() => this.cancelValidate()}>
                                Cancelar
                            </Button>
                            <Button variant={"secondary"} size="sm"  onClick={() => this.confirmationValidateOrder()} disabled={this.state.isEditing}>
                                Validar montos
                            </Button>
                        </Card.Body>
                    </Col>
                </Row>
            </Container>
        )

    }
}

export default withRouter(ValidateAmountView);
